import type { TFunction } from 'i18next';

import type { SmoltLaksvelParameter } from '@/domain/smoltReport';

/** A Laksvel parameter's name, as the New report modal and the report's cards show it. */
export function laksvelParameterLabel(t: TFunction, parameter: SmoltLaksvelParameter): string {
    switch (parameter) {
        case 'bodyWounds':
            return t('smoltReport:laksvelParameters.bodyWounds');
        case 'finDamage':
            return t('smoltReport:laksvelParameters.finDamage');
        case 'gillLid':
            return t('smoltReport:laksvelParameters.gillLid');
        case 'scaleLoss':
            return t('smoltReport:laksvelParameters.scaleLoss');
        case 'snoutWounds':
            return t('smoltReport:laksvelParameters.snoutWounds');
        case 'emaciation':
            return t('smoltReport:laksvelParameters.emaciation');
        case 'deformity':
            return t('smoltReport:laksvelParameters.deformity');
        case 'deformedJaw':
            return t('smoltReport:laksvelParameters.deformedJaw');
        case 'skinBleeding':
            return t('smoltReport:laksvelParameters.skinBleeding');
        case 'cataract':
            return t('smoltReport:laksvelParameters.cataract');
        case 'eyeDamage':
            return t('smoltReport:laksvelParameters.eyeDamage');
        case 'maturity':
            return t('smoltReport:laksvelParameters.maturity');
    }
}
